import React from 'react'
import CatalogItemBaseList, {
  CatalogItemBaseListProps,
} from './CatalogItemBaseList'
import Exporter from 'services/csv/exporter'
import { FILTER_SOURCES } from 'services/cfg/filter'
import TailoredFields from './TailoredFields'

export type MainProductListProps = CatalogItemBaseListProps

const MainProductList: React.FC<MainProductListProps> = ({
  children,
  exporter = Exporter(),
  ...rest
}) => {
  return (
    <CatalogItemBaseList
      exporter={exporter}
      {...rest}
      filterDefaultValues={{ [FILTER_SOURCES.visibleToAll]: true }}
    >
      {children}
      <TailoredFields
        arrayFieldSource={'customersList'}
        chipFieldSource={'email'}
        label={'form.fields.customers'}
        tailoredListField={'customersFull'}
      />
      <TailoredFields
        arrayFieldSource={'organizationsList'}
        chipFieldSource={'name'}
        label={'form.fields.organizations'}
        tailoredListField={'organizationsFull'}
      />
    </CatalogItemBaseList>
  )
}

export default MainProductList
